export default {
  tableHeaders: {
    estimates: {
      index: [
        {
          text: "ID",
          value: "estimates.id",
          sortable: true
        },
        {
          text: "見積明細番号",
          value: "estimates.estimate_cd",
          sortable: true
        },
        {
          text: "商流",
          value: "cases",
          sortable: true
        },
        {
          text: "廃棄物・サービス名",
          value: "waste_work_name",
          sortable: true
        },
        {
          text: "得意先略称",
          value: "customer",
          sortable: true
        },
        {
          text: "事業者略称",
          value: "discharger",
          sortable: true
        },
        {
          text: "事業場略称",
          value: "discharger_site",
          sortable: true
        },
        {
          text: "請求書表示用<br>商品名",
          value: "estimates.invoice_product_name",
          sortable: true
        },
        {
          text: "单位",
          value: "unit",
          sortable: true
        },
        {
          text: "単価",
          value: "estimates.unit_price",
          sortable: true
        },
        {
          text: "原単価",
          value: "estimates.unit_cost",
          sortable: true
        },
        {
          text: "適用終了日",
          value: "estimates.end_date_of_application",
          sortable: true
        },
      ],
    },
    common: {
      searchs: {
        customer: [
          {
            text: "TK管理番号",
            value: "customers.customer_cd",
            sortable: true,
          },
          {
            text: "得意先略称",
            value: "customers.name_abbreviated",
            sortable: true,
          },
          {
            text: "住所",
            value: "address",
            sortable: true,
          },
          {
            text: "TEL",
            value: "customers.tel",
            sortable: true,
          },
          {
            text: "得意先ご担当者",
            value: "customers.customer_person_in_charge",
            sortable: true,
          },
          {
            text: "営業担当者1",
            value: "user_1",
            sortable: true,
          },
          {
            text: "営業担当者2",
            value: "user_2",
            sortable: true,
          },
          {
            text: "営業担当者3",
            value: "user_3",
            sortable: true,
          },
          {
            text: "自社区分",
            value: "zz_own_sort_order",
            sortable: true,
          },
        ],
        user: [
          {
            text: "社員コード",
            value: "users.user_cd",
            sortable: true,
          },
          {
            text: "部署",
            value: "departments.name",
            sortable: true,
          },
          {
            text: "社員名",
            value: "users.user_name",
            sortable: true,
          },
          {
            text: "TEL",
            value: "users.tel",
            sortable: true,
          },
          {
            text: "Email",
            value: "users.email",
            sortable: true,
          },
        ],
        dischargers: [
          {
            text: "JS管理番号",
            value: "dischargers.discharger_cd",
            sortable: true,
          },
          {
            text: "事業者略称",
            value: "dischargers.name_abbreviated",
            sortable: true,
          },
          {
            text: "住所",
            value: "address",
            sortable: true,
          },
          {
            text: "TEL",
            value: "dischargers.tel",
            sortable: true,
          },
          {
            text: "事業者ご担当者",
            value: "dischargers.discharger_person_in_charge",
            sortable: true,
          },

          {
            text: "自社区分",
            value: "zz_own_sort_order",
            sortable: true,
          },
        ],
        discharger_sites: [
          {
            text: "JJ管理番号",
            value: "discharger_sites.discharger_site_cd",
            sortable: true,
          },
          {
            text: "事業場略称",
            value: "discharger_sites.name_abbreviated",
            sortable: true,
          },
          {
            text: "住所",
            value: "address",
            sortable: true,
          },
          {
            text: "TEL",
            value: "discharger_sites.tel",
            sortable: true,
          },
          {
            text: "事業場ご担当者",
            value: "discharger_sites.discharger_site_person_in_charge",
            sortable: true,
          },
          {
            text: "営業担当者1",
            value: "user_1",
            sortable: true,
          },
          {
            text: "営業担当者2",
            value: "user_2",
            sortable: true,
          },

          {
            text: "自社区分",
            value: "zz_own_sort_order",
            sortable: true,
          },
        ],
        project: [
          {
            text: "商流コード",
            value: "cases.case_cd",
            sortable: true,
          },
          {
            text: "商流名",
            value: "cases.case_name",
            sortable: true,
          },
          {
            text: "得意先",
            value: "customer",
            sortable: true,
          },
          {
            text: "事業者",
            value: "discharger",
            sortable: true,
          },
          {
            text: "事業場",
            value: "discharger_site",
            sortable: true,
          },
          {
            text: "関係委託先",
            value: "vendor",
            sortable: true,
          },
        ],
        product_name: [
          {
            text: "商品コード",
            value: "products.product_cd",
            sortable: true,
            width: 10,
          },
          {
            text: "商品略称",
            value: "products.name_abbreviated",
            sortable: true,
            width: 30,
          },
          {
            text: "商品区分2",
            value: "zz_product_2",
            sortable: true,
            width: 60,
          },
        ],
        vendor: [
          {
            text: "IT管理番号",
            value: "vendors.vendor_cd",
            sortable: true,
          },
          {
            text: "委託先略称",
            value: "vendors.name_abbreviated",
            sortable: true,
          },
          {
            text: "住所",
            value: "address",
            sortable: true,
          },
          {
            text: "TEL",
            value: "vendors.tel",
            sortable: true,
          },
          {
            text: "委託先ご担当者",
            value: "vendors.vendor_person_in_charge",
            sortable: true,
          },
          {
            text: "自社区分",
            value: "zz_own_sort_order",
            sortable: true,
          }
        ],
        waste: [
          {
            text: "廃棄物コード",
            value: "wastes.waste_cd",
            sortable: true,
          },
          {
            text: "廃棄物名",
            value: "wastes.name",
            sortable: true,
          },
          {
            text: "商流",
            value: "case_name",
            sortable: true,
          },
          {
            text: "廃棄物分類",
            value: "waste_category_name",
            sortable: true,
          },
        ],
        service: [
          {
            text: "サービスコード",
            value: "services.service_cd",
            sortable: true,
          },
          {
            text: "サービス名",
            value: "services.name",
            sortable: true,
          },
          {
            text: "商流",
            value: "case_name",
            sortable: true,
          },
          {
            text: "サービス分類",
            value: "service_category_name",
            sortable: true,
          },
        ],
      }
    },
    work_orders: {
      wastes_or_services: [
        {
          text: "HK/SG管理番号",
          value: "cd",
          sortable: true,
        },
        {
          text: "名称",
          value: "name",
          sortable: true,
        },
        {
          text: "廃棄物種類",
          value: "waste_category_name",
          sortable: true,
        },
        {
          text: "運搬先",
          value: "vendor_name",
          sortable: true,
        },
        {
          text: "処分方法",
          value: "treatment_method",
          sortable: true,
        },
      ]
    },
    work_reservation: {
      table_estimates: [
        {
          text: "見積明細番号",
          value: "estimate_cd",
          sortable: false,
          width: 20,
        },
        {
          text: "請求書表示用商品名",
          value: "invoice_product_name",
          sortable: false,
          width: 20,
        },
        {
          text: "予定数量",
          value: "",
          sortable: false,
          width: 25,
        },
        {
          text: "単位",
          value: "zz_unit",
          sortable: false,
          width: 10,
        },
        {
          text: "空容器数量<br>（事前申込済のみ）",
          value: "",
          sortable: false,
          width: 25,
        },
      ],
      wastes_or_services: [
        {
          text: "作業指示<br>番号",
          value: "work_order_id",
          sortable: true
        },
        {
          text: "作業指示名",
          value: "name",
          sortable: true
        },
        {
          text: "作業分類",
          value: "work_order_type",
          sortable: true
        },
        {
          text: "選択",
        },
        {
          text: "廃棄物・サービス名",
          value: "waste_or_service_name",
          sortable: true
        },
        {
          text: "廃棄物種類",
          value: "waste_category_of_treatment_name_abbreviated",
          sortable: true
        },
        {
          text: "運搬先",
          value: "vendor_site_name_abbreviated",
          sortable: true
        },
        {
          text: "処分方法",
          value: "treatment_method",
          sortable: true
        },
      ],
      waste_categories: [
        {
          text: "廃棄物分類コード",
          value: "waste_category_cd",
          sortable: true
        },
        {
          text: "廃棄物分類略称",
          value: "name_abbreviated",
          sortable: true
        },
        {
          text: "廃棄物分類種別",
          value: "waste_category_type",
          sortable: true
        },
        {
          text: "商品略称",
          value: "product_name_abbreviated",
          sortable: true
        },
        {
          text: "大分類",
          value: "major_classification",
          sortable: true
        },
        {
          text: "中分類",
          value: "medium_classification",
          sortable: true
        },
        {
          text: "小分類",
          value: "minor_classification",
          sortable: true
        },
      ],
      vendor_sites: [
        {
          text: "委託先事業場コード",
          value: "vendor_site_cd",
          sortable: true
        },
        {
          text: "委託先事業場略称",
          value: "name_abbreviated",
          sortable: true
        },
        {
          text: "住所",
          value: "address",
          sortable: true
        },
        {
          text: "TEL",
          value: "tel",
          sortable: true
        },
        {
          text: "委託先事業場ご担当者",
          value: "vendor_site_person_in_charge",
          sortable: true
        },
        {
          text: "営業担当者1",
          value: "user_name_1",
          sortable: true
        },
        {
          text: "営業担当者2",
          value: "user_name_2",
          sortable: true
        },
        {
          text: "自社区分",
          value: "zz_own_sort_order",
          sortable: true
        },
      ],
      reservation_reflected: [
        {
          text: "収集予定日",
          value: "",
          sortable: false,
        },
        {
          text: "時間帯",
          value: "",
          sortable: false,
          width: 6,
        },
        {
          text: "作業指示<br>番号",
          value: "",
          sortable: false,
        },
        {
          text: "廃棄物種類",
          value: "",
          sortable: false,
        },
        {
          text: "廃棄物・サービス名",
          value: "",
          sortable: false,
        },
        {
          text: "マニフェス<br>ト枚数",
          value: "",
          sortable: false,
          width: 5,
        },
        {
          text: "見積明細番号",
          value: "",
          sortable: false,
        },
        {
          text: "荷姿",
          value: "",
          sortable: false,
        },
        {
          text: "予定数量<br>単位",
          value: "",
          sortable: false,
        },
        {
          text: "運搬先",
          value: "",
          sortable: false,
        },
        {
          text: "処分方法",
          value: "",
          sortable: false,
        },
        {
          text: "予約状況",
          value: "",
          sortable: false,
        },
        {
          text: "操作",
          value: "",
          sortable: false,
        },
      ],
    }
  }
};
